import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_GRIR_CHAT_API || 'https://saviagent.savictech.com/grir/nilons/api/v1';

/**
 * Send a message to the GRIR chatbot
 * @param {string} message - User message
 * @param {Array} conversationHistory - Previous messages in the conversation
 * @returns {Promise} - Response with markdown formatted answer
 */
export const sendGRIRMessage = async (message, conversationHistory = []) => {
  try {
    const payload = {
      message,
      conversation_history: conversationHistory,
    };

    const response = await axios.post(`${API_BASE_URL}/ai/chat`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000,
    });

    return {
      success: true,
      response: response.data.response,
      conversation_history: response.data.conversation_history,
    };
  } catch (error) {
    console.error('Error sending GRIR chat message:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Failed to get response from AI',
      response: null,
      conversation_history: null,
    };
  }
};

/**
 * Predefined queries for quick access
 */
export const GRIR_QUICK_QUERIES = [
  {
    id: 1,
    text: 'Dashboard Summary',
    prompt: 'Give me a summary of current reconciliation status',
  },
  {
    id: 2,
    text: 'Match Rate',
    prompt: 'What is our current match rate?',
  },
  {
    id: 3,
    text: 'Unmatched GR',
    prompt: 'Show me all unmatched GR records',
  },
  {
    id: 4,
    text: 'Unmatched Invoices',
    prompt: 'Show me all unmatched invoices',
  },
  {
    id: 5,
    text: 'Recent Reconciliations',
    prompt: 'Show me the last 5 reconciliation runs',
  },
  {
    id: 6,
    text: 'Amount at Risk',
    prompt: 'How much money is stuck in unmatched records?',
  },
  {
    id: 7,
    text: 'Duplicate Invoices',
    prompt: 'Are there any duplicate invoices?',
  },
  {
    id: 8,
    text: 'Vendor Performance',
    prompt: 'How is vendor V-1001 performing?',
  },
];
